import { render } from "./StyleFull.vue?vue&type=template&id=23c3766a&scoped=true"
import script from "./StyleFull.vue?vue&type=script&lang=js"
export * from "./StyleFull.vue?vue&type=script&lang=js"

import "./StyleFull.vue?vue&type=style&index=0&id=23c3766a&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c3766a"]])

export default __exports__